/**
 * Feature 1 (#157, 2026-05-28): Agreement Interactions API client.
 */
import { api } from './client';
import type {
  AgreementInteraction, AgreementInteractionCreateInput,
  AgreementInteractionFilters, AgreementInteractionUpdateInput, Page, UUID,
} from './types';

export const agreementInteractionsApi = {
  async list(
    filters?: { agreement_id?: UUID; include_deleted?: boolean }
      & AgreementInteractionFilters,
    limit = 50,
    offset = 0,
  ): Promise<Page<AgreementInteraction>> {
    const params = new URLSearchParams({ limit: String(limit), offset: String(offset) });
    if (filters?.agreement_id) params.append('agreement_id', filters.agreement_id);
    if (filters?.include_deleted) params.append('include_deleted', 'true');
    // #41 (2026-06-12) per-column filters — only appended when set, so
    // unfiltered query strings (and their cache keys) stay byte-identical
    // to the pre-#41 shape.
    if (filters?.kind) for (const k of filters.kind) params.append('kind', k);
    if (filters?.date_from) params.append('date_from', filters.date_from);
    if (filters?.date_to) params.append('date_to', filters.date_to);
    if (filters?.q) params.append('q', filters.q);
    if (filters?.person_id) params.append('person_id', filters.person_id);
    if (filters?.user_id) params.append('user_id', filters.user_id);
    if (filters?.author_id) params.append('author_id', filters.author_id);
    return api.get(`/agreement-interactions?${params}`);
  },

  async get(id: UUID): Promise<AgreementInteraction> {
    return api.get(`/agreement-interactions/${id}`);
  },

  async create(input: AgreementInteractionCreateInput): Promise<AgreementInteraction> {
    return api.post('/agreement-interactions', input);
  },

  async update(id: UUID, input: AgreementInteractionUpdateInput): Promise<AgreementInteraction> {
    return api.patch(`/agreement-interactions/${id}`, input);
  },

  async delete(id: UUID): Promise<AgreementInteraction> {
    return api.delete(`/agreement-interactions/${id}`);
  },

  async restore(id: UUID): Promise<AgreementInteraction> {
    return api.post(`/agreement-interactions/${id}/restore`);
  },
};
